import React from 'react';
import { Link } from 'react-router-dom';
import HeaderIcon from 'components/atoms/icons/headerMenuMobileIcon';
import PropTypes from 'prop-types';

const NavBarTitle = ({ showMenu }) => (
  <div className="header-mobile__title">
    <Link data-cy="logged-in-logo" className="header-mobile__logo" to="/" />
    <HeaderIcon onClick={showMenu} />
  </div>
);

NavBarTitle.propTypes = {
  showMenu: PropTypes.func,
};

export default NavBarTitle;
